import React, { useContext } from 'react';
import DataSourcesSelectCOA from 'src/components/calculation-builder/data-sources/SelectCOA';
import DataSourcesMagicBox from 'src/components/calculation-builder/data-sources/MagicBox';
import { DatasetContext } from 'src/components/tp-allocation/shared/DatasetContainer';
import { ACTIONS } from 'src/services/tp-allocation/data-set/DatasetReducer';

interface DasDataSetEditorPanelProps {
    coaTypes: string[];
    sevenSegmentLOV: Map<string, string[]>;
    isSaving: boolean;
    onRecordNeedsSaving: (token: string) => void;
    saveRecordRef: React.MutableRefObject<(() => boolean) | null>;
}

/**
 * COA selection and magic box for the Step 1 row being edited, reading the data set from DatasetContext.
 * Balances are not pulled here; "Save data source" asks the section to save the row.
 */
export default function DasDataSetEditorPanel(props: DasDataSetEditorPanelProps) {
    const { datasetState, datasetDispatch, services } = useContext(DatasetContext);
    const { coaTypes, sevenSegmentLOV, isSaving, onRecordNeedsSaving, saveRecordRef } = props;
    const { datasetRecords, customCoaReference = new Map(), recordBeingEdited, recordBeingEditedOriginal, showDecimals,
        selectedCustomCoaValues } = datasetState;
    return (
        <div className="dataKeyContainer">
            <DataSourcesSelectCOA {...{
                allRecordDescriptions: datasetRecords.map((x) => x.description),
                coaTypes,
                customCoaReference,
                dispatch: datasetDispatch,
                isSaving,
                onRecordNeedsSaving,
                originalRecordDescription: recordBeingEditedOriginal?.description || '',
                recordBeingEdited: { ...recordBeingEdited, entityId: recordBeingEdited?.datasourceId || '' },
                services,
                sevenSegmentLOV,
                showDrillDownSelect: false,
                saveButtonLabel: 'Save data source',
                saveRecordRef,
            }} />
            <DataSourcesMagicBox
                key={recordBeingEdited?.datasourceId}
                recordBeingEdited={recordBeingEdited}
                services={services}
                dispatch={datasetDispatch}
                ACTIONS={ACTIONS}
                showDecimals={showDecimals}
                coaTypes={coaTypes}
                selectedCustomCoaValues={selectedCustomCoaValues}
                sevenSegmentLOV={sevenSegmentLOV}
                allowBalancePull={false} />
        </div>
    );
}
